
<p>{{data}}</p>

<button (click) = "sendData()">click me</button>